import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import VueAwesomeSwiper from "vue-awesome-swiper";

import "swiper/css/swiper.css";

import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload, {
  lazyComponent: true,
  preLoad: 1.3,
  attempt: 1,
});

Vue.config.productionTip = false;

Vue.use(VueAwesomeSwiper);

Vue.mixin({
  computed: {
    largeScreenContainer() {
      if (this.$vuetify.breakpoint.width > 1900) {
        return "margin-left: 320px;  margin-right: 320px";
      } else {
        return "";
      }
    },
  },
});

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
